import { useEffect, useState } from 'react'

import Api from 'services/api'
import { PaywallAcct } from 'types/PaywallAcct'

const usePaywallPremiumAcct = (dealerId) => {
  const [premiumAccount, setPremiumAccount] = useState<PaywallAcct>()
  const [isPremiumAcctLoaded, setIsPremiumAcctLoaded] = useState(false)

  useEffect(() => {
    Api.Paywall.getPremiumAcct(dealerId)
      .then(res => {
        setPremiumAccount(res)
      })
      .catch(() => {
        setIsPremiumAcctLoaded(true)
      })
      .finally(() => setIsPremiumAcctLoaded(true))
  }, [dealerId])

  return { premiumAccount, isPremiumAcctLoaded }
}

export default usePaywallPremiumAcct
